export const VITRINS_OFFER_CARD_TEXTS = {
  PSK: 'ПСК',
  RATE: 'Ставка',
  SUM: 'Сумма',
  TERM: 'Срок',
};
